import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CreateEvent() {
  const navigate = useNavigate();
  const [imageCount, setImageCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    const formData = new FormData(e.currentTarget);
    const title = formData.get('title');
    const date = formData.get('date');
    const description = formData.get('description');
    const rawImages = formData.getAll('images');
    const validImages = rawImages.map(img => img.toString().trim()).filter(Boolean);

    try {
      const response = await fetch('https://sanjaydhir.com/api/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ title, description, date, images: validImages }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Server error saving event');
      }

      setSuccess(true);
      setTimeout(() => navigate('/TalksAndEvents'), 1000);
    } catch (err) {
      setError(err.message || 'Could not connect to backend server.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-4" style={{ maxWidth: '650px', position: 'relative', zIndex: 10 }}>
      <div className="bg-dark text-light border border-secondary rounded-3 p-4 shadow-lg">
        
        <div className="border-bottom border-secondary pb-2 mb-3">
          <span className="text-info text-uppercase fw-bold small">Admin Panel</span>
          <h2 className="h4 text-white mt-1">Create Event</h2>
        </div>

        {error && <div className="alert alert-danger py-2 small">{error}</div>}
        {success && <div className="alert alert-success py-2 small">Event created successfully!</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label small text-secondary fw-semibold">Title</label>
            <input
              name="title"
              type="text"
              required
              placeholder="e.g. Strategic Leadership Conference"
              className="form-control bg-black text-light border-secondary"
            />
          </div>

          <div className="mb-3">
            <label className="form-label small text-secondary fw-semibold">Date</label>
            <input
              name="date"
              type="date"
              required
              defaultValue="2026-08-16"
              className="form-control bg-black text-light border-secondary"
            />
          </div>

          <div className="mb-3">
            <label className="form-label small text-secondary fw-semibold">Description</label>
            <textarea
              name="description"
              required
              rows="4"
              placeholder="Event overview, topics discussed..."
              className="form-control bg-black text-light border-secondary"
            />
          </div>

          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label className="form-label small text-secondary fw-semibold m-0">Image URLs</label>
              <button 
                type="button" 
                onClick={() => setImageCount(c => c + 1)} 
                className="btn btn-sm btn-outline-info"
              >
                + Add Another Image
              </button>
            </div>

            {Array.from({ length: imageCount }).map((_, idx) => (
              <div key={idx} className="d-flex gap-2 mb-2">
                <input
                  name="images"
                  type="url"
                  placeholder={`https://example.com/image-${idx + 1}.jpg`}
                  className="form-control bg-black text-light border-secondary"
                />
                {imageCount > 1 && (
                  <button 
                    type="button" 
                    onClick={() => setImageCount(c => Math.max(1, c - 1))}
                    className="btn btn-sm btn-outline-danger"
                  >
                    ✕
                  </button>
                )}
              </div>
            ))}
          </div>

          <div className="d-flex gap-2 mt-4">
            <button type="submit" disabled={loading} className="btn btn-primary flex-grow-1">
              {loading ? 'Saving...' : 'Save Event'}
            </button>
            <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">
              Cancel
            </button>
          </div>
        </form>

      </div>
    </div>
  );
}